import SectionTable from './SectionTable';
import { ContactSidebarForm } from './ContactSidebarForm';

function Home() {
  return (
    <>
      <SectionTable />
      {/* Contact form, directly below the last matrix. The two wrappers mirror SectionTable's
          own containers so the block lines up with the matrices; the card is capped because
          ContactSidebarForm is sized for the ~320px sidebar and would otherwise stretch to the
          full table width. The last matrix already carries mb-10, so no top margin is needed.
          Layout hides its sidebar copy of this form on "/", so there is only ever one instance. */}
      <section className="container flex flex-col items-center justify-center mx-auto w-full px-2 sm:px-4">
        <div className="flex flex-col justify-center max-w-6xl mx-auto w-full">
          <div className="w-full max-w-md mx-auto mb-10">
            <ContactSidebarForm scrollable={false} />
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
